import React from "react";

export function copyText(text, notify, translate) {
	const notifyError = () => {
		notify(
			<div style={{ width: "80vw", textWrap: "wrap", wordWrap: "break-word" }}>
				{translate("osfc.buttons.copy.error.is_not_supported") + "\n" + text}
			</div>,
			"error",
			{},
			false,
			1000000,
			true
		);
	};
	if (navigator.clipboard) {
		navigator.clipboard
			.writeText(text)
			.then(() => notify(translate("osfc.buttons.copy.success"), "info"))
			.catch(() => notifyError());
	} else {
		notifyError();
	}
}
